import * as angular from "angular";
import * as _ from "lodash";
import {IHttpService, IRootScopeService} from "angular";
import {TravelTimePolygonModel} from "../../site-preferences/models/travel-time-rule.model";
import {CommonsService} from "../../commons/services/commons-service.service";

export class PolygonService {

  public polygonTemp: any = {
    paths: [],
    strokeColor: '#00adee',
    strokeOpacity: 0.8,
    strokeWeight: 2,
    fillColor: '#00adee',
    fillOpacity: 0.2,
    editable: false,
    draggable: false,
    geodesic: true,
    visible: true
  }
  public store: any = {
    polygonOnEdit: {},
    polygonOnCreate: {}
  }

  constructor(private $serviceArea, private $log, private $rootScope: IRootScopeService,
              private ServiceAreaConstants, private $http: IHttpService, private commonsService: CommonsService) {

  }

  parseServiceAreaToPolygonById(_id) {
    const serviceArea = this.$serviceArea(_id).$value();
    const polygon = _.assign({}, this.polygonTemp);

    _.set(polygon, 'id', _id);
    _.set(polygon, 'paths', _.get(serviceArea, 'coordinates', []));
    _.set(polygon, 'fillColor', _.get(serviceArea, 'color', '#00adee'));
    _.set(polygon, 'zIndex', _.toNumber(google.maps.Marker.MAX_ZINDEX) - 100);

    return polygon;
  }

  serviceAreasToPolygons(_scope, _ids) {

    this.removeReferences(_scope);

    const bounds = new google.maps.LatLngBounds();

    if (_ids.length) {

      const polygons = [];

      _.forEach(_ids, (_id) => {
        const polygon = this.parseServiceAreaToPolygonById(_id);
        _.set(polygon, 'map', _scope.map);

        const reference = new google.maps.Polygon(polygon);
        _.set(reference, 'pathRef', polygon.paths);

        _.forEach(polygon.paths, (_path) => {
          bounds.extend(_path);
        });

        this.registerServiceAreaPolygonEvents(reference);

        polygons.push(reference);
      });

      if (_.get(this.store, _scope.$id, false)) {
        _.merge(this.store[_scope.$id], polygons);
      } else {
        _.set(this.store, _scope.$id, polygons);
      }

    }

    return bounds;

  }

  setPolygonEditable(_scope, _id, _value) {

    if (_.get(this.store, 'polygonOnEdit.id', false)) {
      this.store.polygonOnEdit.setOptions({
        strokeColor: '#00adee',
        editable: false,
        draggable: false,
        zIndex: _.toNumber(google.maps.Marker.MAX_ZINDEX) - 100
      });
    }

    let polygon;
    if (_.get(this.store, _scope.$id, false)) {

      polygon = this.findPolygonById(_scope, _id);

      polygon.setOptions({
        strokeColor: 'red',
        editable: _value,
        draggable: _value,
        zIndex: _.toNumber(google.maps.Marker.MAX_ZINDEX) + 100
      });

      _.set(this.store, 'polygonOnEdit', polygon);

    } else {
      this.$log.debug('Failed to find polygon reference! Area Id : ' + _id, _scope);
    }

    const bounds = new google.maps.LatLngBounds();

    _.forEach(_.get(polygon, 'pathRef', []), (_coords) => {
      bounds.extend(_coords);
    });

    return bounds;
  }

  revertChanges(scope, areaId) {
    const polygonToRevert = this.findPolygonById(scope, areaId);
    _.set(this.store, 'polygonOnEdit', {});
    polygonToRevert.setMap(null);

    const originalPolygon = this.parseServiceAreaToPolygonById(areaId);
    _.set(originalPolygon, 'map', scope.map);

    const reference = new google.maps.Polygon(originalPolygon);
    _.set(reference, 'pathRef', originalPolygon.paths);

    this.registerServiceAreaPolygonEvents(reference);

    const cache = _.get(this.store, scope.$id);
    const index = _.findIndex(cache, (polygon: any) => {
      return _.isEqual(polygon.id, areaId);
    });
    cache[index] = reference;
  }

  saveEditedPolygon(_scope, _id, params) {
    this.setPolygonEditable(_scope, _id, false);

    const serviceArea = this.$serviceArea(_id).$value();
    _.set(serviceArea, 'coordinates', []);

    const polygon = this.findPolygonById(_scope, _id);

    polygon.setOptions({
      strokeColor: '#00adee'
    });

    _.forEach(_.get(polygon.getPath(), 'b', []), (_point) => {
      serviceArea.coordinates.push({
        lat: _point.lat(),
        lng: _point.lng()
      });
    });

    this.$serviceArea(_id).$update(serviceArea, {}, params);
  }

  updatePolygon(_scope, _id) {
    this.deletePolygonById(_scope, _id);

    const polygon = this.parseServiceAreaToPolygonById(_id);
    _.set(polygon, 'map', _scope.map);

    const reference = new google.maps.Polygon(polygon);
    _.set(reference, 'pathRef', polygon.paths);

    _.get(this.store, _scope.$id).push(reference);
  }

  createPolygon(_scope, _serviceArea) {
    const polygon = _.assign({}, this.polygonTemp);
    _.set(polygon, 'id', 'new');
    _.set(polygon, 'map', _scope.map);
    _.set(polygon, 'fillColor', _.get(_serviceArea, 'color') || '#000000');
    _.set(polygon, 'zIndex', _.toNumber(google.maps.Marker.MAX_ZINDEX) + 100);

    const reference = new google.maps.Polygon(polygon);
    _.set(reference, 'pathRef', polygon.paths);

    reference.setOptions({
      strokeColor: 'red',
      editable: true,
      draggable: true
    });

    this.registerServiceAreaPolygonEvents(reference);

    _.set(this.store, 'polygonOnCreate', reference);

    const bounds = new google.maps.LatLngBounds();

    _.forEach(_.get(polygon, 'pathRef', []), (_coords) => {
      bounds.extend(_coords);
    });

    return bounds;
  }

  saveCreatedPolygon(_scope, _serviceArea) {
    _.set(_serviceArea, 'coordinates', []);

    const polygon = _.get(this.store, 'polygonOnCreate');

    _.forEach(_.get(polygon.getPath(), 'b', []), (_point) => {
      _serviceArea.coordinates.push({
        lat: _point.lat(),
        lng: _point.lng()
      });
    });

    this.$serviceArea('new').$put(_serviceArea)
      .then((_new) => {
          _.set(polygon, 'id', _.get(_new, 'areaId'));
          polygon.setOptions({
            strokeColor: '#00adee',
            editable: false,
            draggable: false
          });
        }
      );
  }

  removePolygon(_scope, _id) {
    this.findPolygonById(_scope, _id).setMap(null);
  }

  removeOnCreate() {
    if (_.get(this.store, 'polygonOnCreate', false)) {
      _.get(this.store, 'polygonOnCreate').setMap(null);
      _.set(this.store, 'polygonOnCreate', null);
    }
  }

  ///////// HELPERS /////////

  generateUUID() {
    let d = new Date().getTime();
    if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
      d += performance.now();
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      let r = (d + Math.random() * 16) % 16 | 0;
      d = Math.floor(d / 16);
      return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
  }

  getNewPolygon(_scope, _serviceArea) {
    const polygon = _.assign({}, this.polygonTemp);
    _.set(polygon, 'id', 'new');

    const reference = new google.maps.Polygon(polygon);
    _.set(reference, 'pathRef', polygon.paths);

    return polygon;
  }

  removeReferences(_scope) {

    if (_.get(this.store, _scope.$id, false)) {
      _.forEach(_.get(this.store, _scope.$id), (_polygon) => {
        _polygon.setMap(null);
      });

      delete this.store[_scope.$id];
    }

  }

  findPolygonById(_scope, _id) {
    return _.find(_.get(this.store, _scope.$id), (_polygon) => {
      return _.isEqual(_polygon.id, _id);
    });
  }

  deletePolygonById(_scope, _id) {
    if (_.get(this.store, _scope.$id, false)) {
      const cache = _.get(this.store, _scope.$id);

      const polygon = this.findPolygonById(_scope, _id);
      polygon.setMap(null);

      const index = _.findIndex(cache, (_polygon: any) => {
        return _.isEqual(_polygon.id, _id);
      });
      cache.splice(index, 1);
    }
  }

  registerServiceAreaPolygonEvents(polygon) {
    polygon.addListener('click', () => {
      this.$rootScope.$emit(this.ServiceAreaConstants.events.areaPolygonSelectedFromMap, polygon.id);
    });
  }

  getPolygonBoundsById(_scope, _id) {
    const bounds = new google.maps.LatLngBounds();
    const polygon = this.findPolygonById(_scope, _id);

    _.forEach(_.get(polygon, 'pathRef', []), (_coords) => {
      bounds.extend(_coords);
    });

    return bounds;
  }


  getTravelTimeFeatureCollection(travelTimePolygons: TravelTimePolygonModel[]) {
    return {
      type: "FeatureCollection",
      features: this.getTravelTimeFeatures(travelTimePolygons)
    }
  }

  getTravelTimeFeatures(travelTimePolygons: TravelTimePolygonModel[]) {
    return _.map(travelTimePolygons, (p, index) => {
      return {
        type: "Feature",
        id: p.id,
        properties: {
          stroke: '#000000',
          "stroke-width": 2,
          "stroke-opacity": 1,
          fill: this.commonsService.getColorById(p.basedOnArea),
          "fill-opacity": 0.5,
          id: p.id,
          areaId: index,
          areaName: p.basedOnArea
        },
        geometry: {
          type: "Polygon",
          coordinates: this._getCoordinates(p.polygonVertices)

        }
      }
    })
  }


  getFeatureCollection(serviceAreas) {
    return {
      type: "FeatureCollection",
      features: this.getFeatures(serviceAreas)
    }
  }

  getFeatures(serviceAreas) {
    return _.map(serviceAreas, (area) => {
      return {
        type: "Feature",
        properties: {
          stroke: area.color || '#000000',
          "stroke-width": 2,
          "stroke-opacity": 1,
          fill: area.color || '#000000',
          "fill-opacity": 0.5,
          id: area.areaId,
          areaId: area.areaId,
          areaName: area.areaName,
          range: area.range,
          siteId: area.siteId,
          description: area.description,
          branchIds: area.branchIds,
          tags: area.tags,
          branchReferences: area.branchReferences,
          serviceTypes: area.serviceTypes
        },
        geometry: {
          type: "Polygon",
          coordinates: this._getCoordinates(area.coordinates)

        }
      }
    })
  }

  getEmptyFeature() {
    return {
      type: "Feature",
      properties: {
        stroke: '#000000',
        "stroke-width": 2,
        "stroke-opacity": 1,
        fill: '#000000',
        "fill-opacity": 0.5,
        areaId: null,
        areaName: null,
        range: null,
        siteId: null,
        description: null,
        serviceTypes: this.ServiceAreaConstants.serviceTypes
      },
      geometry: {
        type: "Polygon",
        coordinates: []

      }
    }
  }

  _getCoordinates(coordinates) {
    const updatedCoordinates = [];
    _.forEach(coordinates, (coords) => {
      updatedCoordinates.push(
        [(coords.longitude || coords.lng), (coords.latitude || coords.lat)]
      )
    });
    updatedCoordinates.push(updatedCoordinates[0]);
    return [updatedCoordinates]
  }


  getRevertedFeature(feature) {
    return {
      areaId: feature.properties.areaId,
      areaName: feature.properties.areaName,
      color: feature.properties.fill,
      coordinates: this._getRevertedCoordinates(feature.geometry.coordinates),
      description: feature.properties.description,
      id: feature.properties.areaId,
      range: feature.properties.range,
      siteId: feature.properties.siteId,
      branchIds: feature.properties.branchIds,
      branchReferences: feature.properties.branchReferences,
      serviceTypes: feature.properties.serviceTypes,
      tags: feature.properties.tags,
      type: "Polygon"
    }
  }

  getFeatureByAddress(city, country) {
    return this.$http.get('https://nominatim.openstreetmap.org/search.php?q=' + city + '+' + country + '&polygon_geojson=1&format=json')
    // return $http.get('https://nominatim.openstreetmap.org/search.php?q=' + 'חיפה' + '+' + 'ישראל' + '&polygon_geojson=1&format=json')
  }

  getGeofenceZoneFeatureCollection(zones, accountsById?) {
    return {
      type: "FeatureCollection",
      features: this.getGeofenceZoneFeatures(zones, accountsById)
    }
  }

  getGeofenceZoneFeatures(zones, accountsById?) {
    return _.map(zones, (zone) => {
      const account = accountsById ? _.get(accountsById, zone.locationId) : undefined;
      const fill = _.get(account, 'color') || '#00adee';
      const areaName = zone.locationName || _.get(account, 'name') || zone.locationId;
      const coordinates = zone.coordinates && zone.coordinates.length
        ? this._getCoordinates(zone.coordinates)
        : this.getCircleGeoJsonCoordinates(zone.center, zone.radiusMeters);
      return {
        type: "Feature",
        properties: {
          stroke: fill,
          "stroke-width": 2,
          "stroke-opacity": 1,
          fill: fill,
          "fill-opacity": 0.5,
          id: zone.id,
          areaId: zone.id,
          areaName: areaName,
          locationId: zone.locationId,
          locationType: zone.locationType,
          range: zone.radiusMeters,
          siteId: zone.siteId,
          center: zone.center
        },
        geometry: {
          type: "Polygon",
          coordinates: coordinates
        }
      }
    })
  }

  getEmptyGeofenceZoneFeature(locationType) {
    return {
      type: "Feature",
      properties: {
        stroke: '#00adee',
        "stroke-width": 2,
        "stroke-opacity": 1,
        fill: '#00adee',
        "fill-opacity": 0.5,
        areaId: null,
        areaName: null,
        locationId: null,
        locationType: locationType,
        range: null,
        siteId: null,
        center: null
      },
      geometry: {
        type: "Polygon",
        coordinates: []
      }
    }
  }

  getRevertedGeofenceZoneFromFeature(feature) {
    const center = _.get(feature, 'properties.center');
    const range = _.get(feature, 'properties.range');

    const zone: any = {
      locationId: _.get(feature, 'properties.locationId'),
      locationType: _.get(feature, 'properties.locationType'),
      radiusMeters: range,
      center: center ? {
        latitude: _.get(center, 'latitude', _.get(center, 'lat')),
        longitude: _.get(center, 'longitude', _.get(center, 'lng'))
      } : undefined,
      isArchive: false
    };

    const coordinates = this._getRevertedGeofenceZoneCoordinates(feature);
    if (coordinates && coordinates.length) {
      zone.coordinates = coordinates;
    }

    const id = _.get(feature, 'properties.areaId');
    if (id) {
      zone.id = id;
    }
    const siteId = _.get(feature, 'properties.siteId');
    if (siteId) {
      zone.siteId = siteId;
    }
    return zone;
  }

  private _getRevertedGeofenceZoneCoordinates(feature) {
    const ring = _.get(feature, 'geometry.coordinates[0]');
    if (!_.isArray(ring) || !ring.length) {
      return [];
    }
    const points = _.map(ring, (coords) => {
      return {latitude: coords[1], longitude: coords[0]};
    });
    if (points.length > 1 && _.isEqual(points[0], points[points.length - 1])) {
      points.pop();
    }
    return points;
  }

  getCircleGeoJsonCoordinates(center, radiusMeters, numPoints = 64) {
    if (!center || !radiusMeters) {
      return [];
    }
    const lat = _.get(center, 'lat', _.get(center, 'latitude'));
    const lng = _.get(center, 'lng', _.get(center, 'longitude'));
    if (!_.isFinite(lat) || !_.isFinite(lng)) {
      return [];
    }
    const earthRadius = 6378137;
    const latRad = lat * Math.PI / 180;
    const ring = [];
    for (let i = 0; i < numPoints; i++) {
      const bearing = (i * 360 / numPoints) * Math.PI / 180;
      const dLat = (radiusMeters * Math.cos(bearing)) / earthRadius;
      const dLng = (radiusMeters * Math.sin(bearing)) / (earthRadius * Math.cos(latRad));
      ring.push([lng + dLng * 180 / Math.PI, lat + dLat * 180 / Math.PI]);
    }
    ring.push(ring[0]);
    return [ring];
  }

  _getRevertedCoordinates(coordinates) {
    const updatedCoordinates = _.map(coordinates[0], (coords) => {
      return {longitude: coords[0], lng: coords[0], latitude: coords[1], lat: coords[1]}
    });
    updatedCoordinates.splice(updatedCoordinates.length - 1, 1);
    return updatedCoordinates;
  }

}

angular
  .module('bringoz.admin.service-areas')
  .service('polygonService', PolygonService);
